import React from 'react';
import { EMAIL_SERVICES } from 'constants/common';

type Props = {
  esp: string,
};

const getImageUrlAndText = (esp: string) => {
  switch (esp) {
    case EMAIL_SERVICES.GMAIL:
      return { url: '/esp-icons/gsuite.png', text: 'GSuite' };
    case EMAIL_SERVICES.MICROSOFT:
      return { url: '/esp-icons/microsoft.png', text: 'Microsoft' };
    default:
      return { url: null, text: esp };
  }
};

export default function ESPRenderer({ esp }: Props) {
  const { url, text } = getImageUrlAndText(esp);
  return (
    <div className="flex items-center space-x-2">
      {url && <img alt={esp} src={url} style={{ width: 24, height: 24 }} />}
      <span>{text}</span>
    </div>
  );
}
